var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "password-step" },
    [
      _c("div", { staticClass: "fm-info-banner mb-4" }, [
        _c(
          "svg",
          {
            attrs: {
              fill: "currentColor",
              viewBox: "0 0 16 16",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "Create a password to access your Flash Money account and track your application."
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "FormGroup",
        {
          attrs: {
            "error-container": _vm.errorContainerName,
            label: "New Password",
            name: "password",
            floating: true,
          },
        },
        [
          (_vm.showPassword ? "text" : "password") === "checkbox"
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.password,
                    expression: "form.password",
                  },
                ],
                staticClass: "form-control",
                attrs: { placeholder: " ", type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.form.password)
                    ? _vm._i(_vm.form.password, null) > -1
                    : _vm.form.password,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.form.password,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(_vm.form, "password", $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.form,
                            "password",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.form, "password", $$c)
                    }
                  },
                },
              })
            : (_vm.showPassword ? "text" : "password") === "radio"
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.password,
                    expression: "form.password",
                  },
                ],
                staticClass: "form-control",
                attrs: { placeholder: " ", type: "radio" },
                domProps: { checked: _vm._q(_vm.form.password, null) },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.form, "password", null)
                  },
                },
              })
            : _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.password,
                    expression: "form.password",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  placeholder: " ",
                  type: _vm.showPassword ? "text" : "password",
                },
                domProps: { value: _vm.form.password },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "password", $event.target.value)
                  },
                },
              }),
        ]
      ),
      _vm._v(" "),
      _vm.form.password
        ? _c("div", { staticClass: "pwd-strength mb-3" }, [
            _c("div", { staticClass: "pwd-strength__bar" }, [
              _c("div", {
                staticClass: "pwd-strength__fill",
                class: `pwd-strength__fill--${_vm.strength.level}`,
                style: { width: _vm.strength.pct + "%" },
              }),
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "pwd-strength__label",
                class: `pwd-strength__label--${_vm.strength.level}`,
              },
              [_vm._v(_vm._s(_vm.strength.label))]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "FormGroup",
        {
          attrs: {
            "error-container": _vm.errorContainerName,
            label: "Confirm Password",
            name: "password_confirmation",
            floating: true,
          },
        },
        [
          (_vm.showPassword ? "text" : "password") === "checkbox"
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.password_confirmation,
                    expression: "form.password_confirmation",
                  },
                ],
                staticClass: "form-control",
                attrs: { placeholder: " ", type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.form.password_confirmation)
                    ? _vm._i(_vm.form.password_confirmation, null) > -1
                    : _vm.form.password_confirmation,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.form.password_confirmation,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.form,
                            "password_confirmation",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.form,
                            "password_confirmation",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.form, "password_confirmation", $$c)
                    }
                  },
                },
              })
            : (_vm.showPassword ? "text" : "password") === "radio"
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.password_confirmation,
                    expression: "form.password_confirmation",
                  },
                ],
                staticClass: "form-control",
                attrs: { placeholder: " ", type: "radio" },
                domProps: {
                  checked: _vm._q(_vm.form.password_confirmation, null),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.form, "password_confirmation", null)
                  },
                },
              })
            : _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.password_confirmation,
                    expression: "form.password_confirmation",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  placeholder: " ",
                  type: _vm.showPassword ? "text" : "password",
                },
                domProps: { value: _vm.form.password_confirmation },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.form,
                      "password_confirmation",
                      $event.target.value
                    )
                  },
                },
              }),
        ]
      ),
      _vm._v(" "),
      _c("label", { staticClass: "fm-toggle-show" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.showPassword,
              expression: "showPassword",
            },
          ],
          attrs: { type: "checkbox" },
          domProps: {
            checked: Array.isArray(_vm.showPassword)
              ? _vm._i(_vm.showPassword, null) > -1
              : _vm.showPassword,
          },
          on: {
            change: function ($event) {
              var $$a = _vm.showPassword,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.showPassword = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.showPassword = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.showPassword = $$c
              }
            },
          },
        }),
        _vm._v(" Show password\n  "),
      ]),
      _vm._v(" "),
      _vm._t("controls", null, null, { prev: _vm.onPrev, next: _vm.onNext }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }